import { SectionMenu } from "..";
import { memo } from "react";
import { mapTabs } from "../../../consts/tabs";
import { ArtificialPostcodeDetail } from "../../ArtificialPostcodeDetail";
import { OUTER, SECTOR, POSTCODE } from "../../../consts/layers";

export const MapSections = memo(() => {
  return (
    <SectionMenu tabs={mapTabs}>
      <SectionMenu.SectionMenuItem id={0}>
        <ArtificialPostcodeDetail level={OUTER} />
      </SectionMenu.SectionMenuItem>
      <SectionMenu.SectionMenuItem id={1}>
        <ArtificialPostcodeDetail level={SECTOR} />
      </SectionMenu.SectionMenuItem>
      <SectionMenu.SectionMenuItem id={2}>
        <ArtificialPostcodeDetail level={POSTCODE} />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
